import {
  checkboxSchema,
  checkboxUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../locales/en/content.json';
import FieldsetLabel from '../../../../components/FormDescriptions/FieldsetLabel';

const TITLE_TEXT = content['service-info--history-title'];
const FIELDSET_LABEL = content['service-info--history-label'];
const INPUT_LABELS = {
  purpleHeart: content['service-info--history-option--purple-heart'],
  pow: content['service-info--history-option--pow'],
  combatTheater: content['service-info--history-option--combat-theater'],
  lineOfDuty: content['service-info--history-option--disability'],
  swAsia: content['service-info--history-option--sw-asia'],
};

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    'view:serviceHistory': {
      'ui:title': FieldsetLabel(FIELDSET_LABEL),
      purpleHeartRecipient: checkboxUI(INPUT_LABELS.purpleHeart),
      isFormerPow: checkboxUI(INPUT_LABELS.pow),
      postNov111998Combat: checkboxUI(INPUT_LABELS.combatTheater),
      disabledInLineOfDuty: checkboxUI(INPUT_LABELS.lineOfDuty),
      swAsiaCombat: checkboxUI(INPUT_LABELS.swAsia),
    },
  },
  schema: {
    type: 'object',
    properties: {
      'view:serviceHistory': {
        type: 'object',
        properties: {
          purpleHeartRecipient: checkboxSchema,
          isFormerPow: checkboxSchema,
          postNov111998Combat: checkboxSchema,
          disabledInLineOfDuty: checkboxSchema,
          swAsiaCombat: checkboxSchema,
        },
      },
    },
  },
};
